import React from 'react';
import { ACTIONS_TYPES, actions } from 'redux/local';
import Shared from 'screens/shared';
import { varToText } from 'utils';
import CreateForm from './create';

export default ({
  rules = [], readonly = false, dcId, serverId, nicId,
}) => {
  const deleteHandler = ({ id: ruleId }) => {
    actions.nic.firewallRuleDelete({
      dcId, nicId, ruleId, serverId,
    });
  };

  const setItemDetails = ({
    properties: {
      icmpType, icmpCode, sourceMac, portRangeStart, portRangeEnd, sourceIp, targetIp,
    },
  }) => (
    Object.entries({
      sourceMac, icmpType, icmpCode, portRangeStart, portRangeEnd, sourceIp, targetIp,
    }).filter((e) => e[1]).map(([key, value]) => <span className="m-r-20" key={key}>{`${varToText(key)}: ${value}`}</span>)
  );

  return (
    <Shared.widgets.Section
      sectionTitle="Firewall Rules"
      itemIcon="shield-alt"
      className="-m-t-24"
      isAddButton={!readonly}
      createForm={<CreateForm {...{ dcId, serverId, nicId }} />}
      createActionType={ACTIONS_TYPES.NIC.FIREWALL_RULE_ADD}
      items={rules}
      setItemTitle={(e) => `${e?.properties?.name} - ${e?.properties?.type} - ${e?.properties?.protocol}`}
      setItemDetails={setItemDetails}
      itemOnDelete={deleteHandler}
      isDeletePassword
    />
  );
};
